<template>
	<div>
		<!-- <el-tabs v-model="tabName">
			<el-tab-pane label="ក្រុមហ៊ុនទាំងអស់" name="first"></el-tab-pane>
		</el-tabs> -->


		<div v-if="tabName == 'first'">
			<!-- <div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<md-select placeholder="តំបន់អាជីវកម្ម" v-model="search.location" @md-selected="">
							<md-option value="">ទាំងអស់</md-option>
							<md-option v-for="location in locationList" :value="location.id">{{location.name}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<md-select placeholder="ស្ថានភាពអាជីវកម្ម" v-model="search.status" @md-selected="">
							<md-option value="">ទាំងអស់</md-option>
							<md-option v-for="status in statusList" :value="status.id">{{status.name}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-33">
					<md-field>
						<md-select placeholder="ប្រភេទអាជីវកម្ម" v-model="search.type" @md-selected="">
							<md-option value="">ទាំងអស់</md-option>
							<md-option v-for="business in businessList" :value="business.id">{{business.name}}</md-option>
						</md-select>
					</md-field>
				</div>

				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="searchHandler()">ស្វែងរក
					</md-button>
				</div>
			</div> -->
			<div class="md-layout-item md-size-100 text-right">

				<download-excel :meta="json_meta" :data="companyList" :fields="companyHeader" worksheet="Company"
					name="company.xls">
					<md-button class="md-raised md-primary">ទាញយក</md-button>
				</download-excel>
			</div>


			<md-table>
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>ឈ្មោះក្រុមហ៊ុន</md-table-head>
					<md-table-head>ឈ្មោះម្ចាស់ក្រុមហ៊ុន</md-table-head>
					<md-table-head>សញ្ជាតិម្ចាស់ក្រុមហ៊ុន</md-table-head>
					<md-table-head>តំបន់អាជីវកម្ម</md-table-head>
					<md-table-head>ទីតាំងអាជីវកម្ម</md-table-head>
					<md-table-head>ផ្ទៃក្រឡាដី</md-table-head>
					<md-table-head>ប្រភេទអាជីវកម្ម</md-table-head>
					<md-table-head>លេខអាជ្ញាបណ្ណ</md-table-head>
					<md-table-head>ថ្ងៃចេញអាជ្ញាបណ្ណ</md-table-head>
					<md-table-head>ថ្ងៃមានសុពលភាព</md-table-head>
					<md-table-head>ថ្ងៃផុតសុពលភាព</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(company, index) in companyList">
					<md-table-cell><b>{{company.id}}</b></md-table-cell>
					<md-table-cell><b>{{company.name}}</b></md-table-cell>
					<md-table-cell><b>{{company.owner}}</b></md-table-cell>
					<md-table-cell><b>{{company.nationality}}</b></md-table-cell>
					<md-table-cell><b>{{company.location}}</b></md-table-cell>
					<md-table-cell><b>{{company.address}}</b></md-table-cell>
					<md-table-cell><b>{{company.area}}</b></md-table-cell>
					<md-table-cell><b>{{company.type}}</b></md-table-cell>
					<md-table-cell><b>{{company.number}}</b></md-table-cell>
					<md-table-cell><b>{{company.issue_date}}</b></md-table-cell>
					<md-table-cell><b>{{company.active_date}}</b></md-table-cell>
					<md-table-cell><b>{{company.expiry_date}}</b></md-table-cell>
					<md-table-cell>{{company.status}}</md-table-cell>
				</md-table-row>
			</md-table>

		</div>

		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុយក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getCompany();

		},

		data() {
			return {
				tabName: "first",
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					searchText: "",
					location: "",
					status: "",
					type: ""
				},
				isValid: false,
				companyList: [],
				companyHeader: {
					'ល.រ': 'id',
					'ឈ្មោះក្រុមហ៊ុន': 'name',
					'ឈ្មោះម្ចាស់ក្រុមហ៊ុន': 'owner',
					'សញ្ជាតិម្ចាស់ក្រុមហ៊ុន': 'nationality',
					'តំបន់អាជីវកម្ម': 'location',
					'ទីតាំងអាជីវកម្ម': 'address',
					'ផ្ទៃក្រឡាដី': 'area',
					'ប្រភេទអាជីវកម្ម': 'type',
					'លេខអាជ្ញាបណ្ណ': 'number',
					'ថ្ងៃចេញអាជ្ញាបណ្ណ': 'issue_date',
					'ថ្ងៃមានសុពលភាព': 'active_date',
					'ថ្ងៃផុតសុពលភាព': 'expiry_date',
					'ស្ថានភាព': 'status'
				},
				json_meta: [
					[
						{
							'key': 'charset',
							'value': 'utf-8'
						}
					]
				]
			}
		},
		methods: {

			getCompany(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/stats/get/list/" + offset).then(data => {
					let company = [];
					// this.companyList = replace ? data.body.data : this.companyList.concat(data.body.data)

					for (let i = 0; i < data.body.data.length; i++) {
						company.push({
							id: i + 1,
							name: data.body.data[i].name,
							owner: data.body.data[i].owner,
							nationality: data.body.data[i].nationality,
							location: data.body.data[i].location,
							address: data.body.data[i].address,
							area: data.body.data[i].area,
							type: data.body.data[i].type,
							number: data.body.data[i].number,
							issue_date: this.config.datelify(data.body.data[i].issue_date),
							active_date: this.config.datelify(data.body.data[i].active_date),
							expiry_date: this.config.datelify(data.body.data[i].expiry_date),
							status: data.body.data[i].status
						})
					}
					this.companyList = company;
				})
			},
			searchHandler() {
				this.$http.post(this.config.api + "/admin/company/search", {
					text: this.search.searchText,
					type: this.search.type,
					location: this.search.location,
					status: this.search.status
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(data => {
					this.search.searchText = "";
					this.searchList = data.body.data;
				})
			},
			loadMoreCompany() {

				this.getCompany(this.companyList.length, false);
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				console.log(this.deleteSelected);
				this.$http.post(this.config.api + "/admin/company/delete", {
					company_id: this.deleteSelected
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Company was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						this.getCompany();
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Stats/View.vue